import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(({ spacing, palette,variables }) => ({
  orderDetailWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: variables?.spacingD,
    paddingBottom: 0,
    '&.mobile': {
      position: 'fixed',
      bottom: '86px',
      left: variables?.spacingC,
      right: variables?.spacingC,
      zIndex: 1,
      flexWrap: 'wrap',
      flexDirection: 'column',
      background: '#fff',
      borderRadius:variables?.radiusRoundedC,
      boxShadow: variables?.elevation01,
    },
    /*
    '&.mobile': {
      zIndex: 999,
      position: 'fixed',
      bottom: variables?.spacingH,
      left: variables?.spacingE,
      right: variables?.spacingE,
      background: 'white',
      minHeight: '100px',
      maxHeight: '180px',
      borderTop: `1px solid ${palette.jet?.borderDefault}`,
      borderRadius:variables?.radiusRoundedC,
      '& ul': {
        overflow: 'hidden',
      },
      '&.orderDetail': {
        position:'absolute',
        top:0
      }
    },*/
  },
  orderTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'row',
    width: '100%',
  },
  closeButton: {
    position: 'relative',
    display: 'flex',
    top: `-${variables?.spacingB}px`,
  },
  closeButtonIcon: {
    width: variables?.spacingD,
    height: variables?.spacingD,
  },
  list: {
    margin: 0,
    padding: 0,
    paddingTop: '5px',
    paddingBottom: '16px',
    listStyle: 'none',
    width: '100%',
    '& li': {
      margin: `${variables?.spacingNone} ${variables?.spacingNone} ${variables?.spacingD}`,
      width: '100%',
      '&:last-child': {
        margin: 0,
      },
    },
  },
}));

export default styles;
